import { ActivityBadge } from '@pages/Payouts/Details/ActivityBadge';

import { TRANSLATIONS } from './constants';

type ActivityDetailProps = {
  createdAt?: string;
  createdBy?: string;
};

export const ActivityDetails = ({
  createdAt,
  createdBy
}: ActivityDetailProps) => {
  if (!createdAt && !createdBy) {
    return null;
  }

  return (
    <div className="break-words pb-2">
      <p className="pb-2 text-base text-content-secondary">
        {TRANSLATIONS.ACTIVITY_TITLE}
      </p>

      <ActivityBadge
        kind="userCreated"
        name={createdBy || TRANSLATIONS.UNKNOWN_USER_TITLE}
        timestamp={createdAt}
      />
    </div>
  );
};
